<script lang="ts">
  import "$lib/styles/lazyLoad.css";
  import type { Contributions } from "$types";
  import { colors, activeColor } from "$lib/data";
  import { mobile_size_large } from "$components/episodes/gallery_store";

  export let gallery: Contributions[];
  export let context: string;
  export let base: string;
  export let admin_mode: boolean = false;

  import GalleryImage from "./GalleryImage-new.svelte";
  import GalleryImageCommunity from "./GalleryImage-community.svelte";
  import GalleryImageCommunityBonus from "./GalleryImage-community-bonus.svelte";
</script>

<div
  class="gallery"
  class:mobile_small={!$mobile_size_large}
  style="
            --primary: {colors[$activeColor].color};
            --secondary: {colors[$activeColor].highlight};
        "
  class:enlarge={gallery.length === 1}
  class:live={context === "live"}
>
  {#each gallery as contribution}
    {#if contribution.image}
      {#if context === "community"}
        <GalleryImageCommunity {contribution} {base} />
      {:else if context === "community-bonus"}
        <GalleryImageCommunityBonus {contribution} {base} />
      {:else}
        <GalleryImage {context} {contribution} {base} {admin_mode} />
      {/if}
    {/if}
  {/each}
</div>

<style>
  .gallery {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-column-gap: 1rem;
    grid-row-gap: 2rem;
    margin-bottom: 3rem;
  }
  .gallery.live {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  @media (max-width: 600px) {
    .gallery {
      padding: 1rem;
      grid-template-columns: 1fr;
    }
    .gallery.enlarge {
      grid-template-columns: 1fr;
    }
    .gallery.live {
      grid-template-columns: 1fr;
    }
    .gallery.mobile_small {
      grid-template-columns: 1fr 1fr;
      gap: 0.4rem;
      padding: 0.2rem;
    }
  }
</style>
